// Helpers for handling visible placeholders in ticket templates

export const PLACEHOLDER_VISIBLE = '___';
export const PLACEHOLDER_REGEX = /\{[^}]+}/g;

// Centralized constants for the Period placeholder
export const PERIOD_PLACEHOLDER_NAME = 'Period';
export const PERIOD_PLACEHOLDER_TOKEN = `{${PERIOD_PLACEHOLDER_NAME}}`;
export const PERIOD_PLACEHOLDER_REGEX = new RegExp(`\\{${PERIOD_PLACEHOLDER_NAME}\\}`, 'g'); // exact match for {Period}

/**
 * Replace {Period} with the provided periodName (if available) before prettifying.
 * If periodName is absent, use the visible placeholder instead.
 */
export const replacePeriodBeforePrettify = (str?: string | null, periodName?: string | null): string => {
  if (!str) return '';
  if (!str.includes(PERIOD_PLACEHOLDER_TOKEN)) return str;
  const replacement = periodName && periodName.trim() ? periodName.trim() : PLACEHOLDER_VISIBLE;
  return str.replace(PERIOD_PLACEHOLDER_REGEX, replacement);
};

/**
 * Replaces all occurrences of `{Var}`-style placeholders with a visible token (e.g., ___)
 */
export const prettifyPlaceholders = (str?: string | null): string => {
  if (!str) return '';
  return str.replace(PLACEHOLDER_REGEX, PLACEHOLDER_VISIBLE);
};

/**
 * Extracts placeholder names from a string containing `{Var}` placeholders.
 * Returns a unique list of names without braces.
 */
export const extractPlaceholderNames = (str?: string | null): string[] => {
  if (!str) return [];
  const matches = str.match(/\{([^}]+)}/g) || [];
  const names = matches.map((m) => m.slice(1, -1).trim()).filter(Boolean);
  return Array.from(new Set(names));
};

/**
 * Given text and cursor position, returns [start, end] of a visible placeholder token if the cursor is inside it.
 */
export const getPlaceholderRangeAtPos = (text: string, pos: number): [number, number] | null => {
  if (!text || pos < 0) return null;
  const token = PLACEHOLDER_VISIBLE;
  const tLen = token.length;
  let idx = -1;
  while ((idx = text.indexOf(token, idx + 1)) !== -1) {
    const start = idx;
    const end = idx + tLen;
    if (pos >= start && pos <= end) return [start, end];
  }
  return null;
};
